import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/webapp-common.dto';

import {
  GetJobQuery,
  GetJobResponse,
  type Job,
} from '@hud/portal-dtos/pr-comparisons.dto';
import { PORTAL_BASE } from '../consts';

export const JOB_ID = 'job';

export default function useJob(jobId?: Job['id'], params?: GetJobQuery) {
  const { client, isReady } = useClient();
  return useQuery<GetJobResponse, AxiosError<ErrorResponse>>({
    queryKey: [JOB_ID, jobId, params],
    queryFn: async () => {
      const response = await client.get<GetJobResponse>(
        `${PORTAL_BASE}/jobs/${jobId}`,
        {
          params,
        },
      );
      return GetJobResponse.parse(response.data);
    },
    enabled: jobId !== undefined && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
